export const toCapitalize = (word) => word[0].toLocaleUpperCase() + word.slice(1);
